if(!customElements.get('review-card')) {
  customElements.define(
    'review-card',
    class ReviewCard extends HTMLElement {
      #review;
      #readMoreButton;
      #resizeObserver;

      constructor() {
        super();
      }

      connectedCallback() {
        this.#review = this.querySelector('[data-review]');
        this.#readMoreButton = this.querySelector('[data-trigger]');
        this.init();
      }

      disconnectedCallback() {
        this.#resizeObserver?.disconnect();
      }

      init() {
        if(!this.#review || !this.#readMoreButton) return;

        this.#readMoreButton.addEventListener('click', () => {
          this.#review.classList.toggle('expanded');
          this.#readMoreButton.textContent =
            this.#review.classList.contains("expanded") ? "Read less" : "Read more"
        });

        this.#checkOverflow();

        this.#resizeObserver = new ResizeObserver(() => this.#checkOverflow());
        this.#resizeObserver.observe(this.#review);

        if(document.fonts?.ready) {
          document.fonts.ready.then(() => this.#checkOverflow());
        }
      }

      #checkOverflow() {
        if(this.#review.classList.contains('expanded')) return;
        const hasOverflow = this.#review.scrollHeight > this.#review.clientHeight + 1;
        this.#review.classList.toggle('has-overflow', hasOverflow);
      }
    }
  );
}
